import { LoginModal, PageContainer } from "components";
import {
  ConfirmationModal,
  ErrorModal,
  InfoModal,
  AddEditEdDeptInfoModal,
  AddEditProspectiveModal,
} from "components/reusables";
import { UserContext } from "contexts";
import React, { useContext, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useHistory, useLocation } from "react-router-dom";
import { loginAsAdmin, logout, sendPasswordResetEmail } from "services";
// import { setTimeout } from "timers";
// import { setTimeout } from "timers-browserify";
import { URLPaths } from "utilities";
import "./EdDepAdmin.scss";

export function EdDepAdmin(): JSX.Element {
  const user = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowingConfirmPasswordReset, setIsShowingConfirmPasswordReset] = useState(false);
  const [isShowingEmailSent, setIsShowingEmailSent] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const history = useHistory();
  const location = useLocation();
  const [isShowingEditModal, setIsShowingEditModal] = useState(false);
  const [isShowingProspectiveEditModal, setIsShowingProspectiveEditModal] = useState(false);
  const [isUploadingMultipleSlide, setIsUploadingMultipleSlide] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    /* Adds a little bit of buffer time to check if user exists, so that if the
     * user IS logged in, they don't see the login modal briefly when opening the
     * admin page. */
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  return isLoading ? (
    <div id="loader">
      <PageContainer>
        <Spinner animation="border" />{" "}
        {/* Spinner is that loading spinning circle that lets the user know the page is loading */}
      </PageContainer>
    </div>
  ) : (
    <>
      <div id="page">
        <LoginModal
          isLoggedIn={!!user}
          loginFn={loginAsAdmin}
          title="Admin Login"
          description="Please login using your admin credentials to view this content."
          passwordResetFn={sendPasswordResetEmail}
        />
        <PageContainer>
          <>
            <div className="flex-container">
              <div className="go-back-ed">
                <Button
                  variant="outline-secondary"
                  onClick={() => history.push("education-department-info")}
                >
                  Back To Page
                </Button>
              </div>
              <div className="logout-ed">
                <Button
                  variant="outline-secondary"
                  onClick={() =>
                    logout().then(() =>
                      location.pathname === URLPaths.edDepInfoAdmin
                        ? history.push(URLPaths.edDepInfoAdmin)
                        : history.push(URLPaths.edDepInfoAdmin),
                    )
                  }
                >
                  Log Out
                </Button>
              </div>
            </div>
            <hr className="less-top-margin" />
            <h2>Department Updates</h2>
            <div className="flex-container-ed">
              <div style={{ paddingBlockStart: "1rem" }}>
                <Button
                  className="ed-dep-admin-button1"
                  variant="outline-primary"
                  onClick={() => {
                    setIsShowingProspectiveEditModal(true);
                    setIsUploadingMultipleSlide(false);
                  }}
                  size="lg"
                >
                  Add a Single &quot;Department Updates&quot; Slide
                </Button>
                <h5 style={{ paddingBlockStart: ".5rem" }}>
                  With this button, you may add one individual slide to the existing slideshow.
                </h5>
              </div>
              <div style={{ paddingBlockStart: "1rem" }}>
                <Button
                  className="ed-dep-admin-button"
                  variant="outline-success"
                  onClick={() => {
                    setIsShowingProspectiveEditModal(true);
                    setIsUploadingMultipleSlide(true);
                  }}
                  size="lg"
                >
                  Replace All &quot;Department Updates&quot; Slides
                </Button>
                <h5 style={{ paddingBlockStart: ".5rem" }}>
                  Here you may upload a new set of slides into the &quot;Department Updates&quot;
                  slideshow. This button will automatically delete the current set of slides and
                  replace them with the uploaded slides.
                </h5>
              </div>
            </div>
            <hr />
            <h2>Going Into Education</h2>
            <div className="flex-container-ed" style={{ paddingBlockStart: "1rem" }}>
              <div>
                <Button
                  className="ed-dep-admin-button1"
                  variant="outline-primary"
                  onClick={() => {
                    setIsShowingEditModal(true);
                    setIsUploadingMultipleSlide(false);
                  }}
                  size="lg"
                >
                  Add a Single &quot;Going Into Education&quot; Slide
                </Button>
                <h5 style={{ paddingBlockStart: ".5rem" }}>
                  With this button, you may add one individual slide to the existing slideshow.
                </h5>
              </div>
              <div>
                {" "}
                <Button
                  className="ed-dep-admin-button"
                  variant="outline-success"
                  onClick={() => {
                    setIsShowingEditModal(true);
                    setIsUploadingMultipleSlide(true);
                  }}
                  size="lg"
                >
                  Replace All &quot;Going Into Education&quot; Slides
                </Button>{" "}
                <h5 style={{ paddingBlockStart: ".5rem" }}>
                  Here you may upload a new set of slides into the &quot;Going Into Education&quot;
                  slideshow. This button will automatically delete the current set of slides and
                  replace them with the uploaded slides.
                </h5>
              </div>
            </div>
          </>
        </PageContainer>

        <AddEditEdDeptInfoModal
          show={isShowingEditModal}
          setShow={setIsShowingEditModal}
          currentSlide={undefined}
          multipleSlideUpload={isUploadingMultipleSlide}
        />

        <AddEditProspectiveModal
          show={isShowingProspectiveEditModal}
          setShow={setIsShowingProspectiveEditModal}
          currentSlide={undefined}
          multipleSlideUpload={isUploadingMultipleSlide}
        />

        <ConfirmationModal
          show={isShowingConfirmPasswordReset}
          onHide={() => setIsShowingConfirmPasswordReset(false)}
          onConfirm={() => {
            return sendPasswordResetEmail(user?.email || "")
              .then(() => setIsShowingEmailSent(true))
              .catch(err => setError(err));
          }}
          title="Send password reset email?"
          message={`An email will be sent to ${user?.email} with a link to reset your password.`}
          confirmText="Send Email"
        />
        <InfoModal
          show={isShowingEmailSent}
          onHide={() => setIsShowingEmailSent(false)}
          title="Email Sent"
          message="Please check your inbox."
        />
        <ErrorModal error={error} />
      </div>
    </>
  );
}
